/*
 * @Author: MWeiLiu
 * @Date: 2019-12-17 20:11:14
 * @Last Modified by: MWeiLiu
 * @Last Modified time: 2021-04-06 22:48:45
 */
import Vue from 'vue'
import Vuex from 'vuex'

import parkActivitiesList from './modules/circle/parkActivitiesList.js'
import demandSquareList from './modules/circle/demandSquareList.js'
import parkActivitiesDetail from './modules/circle/parkActivitiesDetail.js'
import articleList from './modules/circle/articleList'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    articleList,
    parkActivitiesList,
    demandSquareList,
    parkActivitiesDetail
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js